<template lang='pug'>
  i.svg-icon.svg-icon-confirmAnimate
    svg(
      :stroke='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 60 60'
      class='confirmAnimate'
    )
      circle(class="confirmAnimate-circle" cx="30" cy="30" r="30" fill="none" :stroke='color')
      path(class="confirmAnimate-check" fill="none" d="m12.5 28l10.0 13 24-22.2")


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#50E38E',
    },
  },

}
</script>

<style lang='scss'>
  .confirmAnimate {
    display: block;
    border-radius: 50%;
    margin: 10px auto;
    -webkit-animation: bounceIcon .17s ease-in-out;
    animation: bounceIcon .17s ease-in-out;
    -webkit-animation-delay: .25s;
    animation-delay: .25s;
  }

  .confirmAnimate-circle {
    stroke-dasharray: 190;
    stroke-dashoffset: 190;
    stroke-width: 9;
    fill: none;
    -webkit-animation: drawCircle .2s linear;
    animation: drawCircle .2s linear;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .confirmAnimate-check {
    stroke-width: 7;
    stroke-dasharray: 120;
    stroke-dashoffset: 120;
    -webkit-animation: drawCheckmark .2s cubic-bezier(.89,.09,.91,.67);
    animation: drawCheckmark .2s cubic-bezier(.89,.09,.91,.67) forwards;
    -webkit-animation-delay: .2s;
    animation-delay: .2s;
  }

  @keyframes drawCircle {
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes drawCheckmark {
    100% {
      opacity: 1;
      stroke-dashoffset: 0;
    }
  }

  @keyframes bounceIcon {
    0% {
      transform: none;
    }
    50% {
      transform: scale3D(.9, .9, 1);
    }
    100% {
      transform: none;
    }
  }
</style>